<script setup>
import ProgressBar from '@/components/shared/core/ProgressBar.vue'
import StatusBadge from '@/components/shared/core/StatusBadge.vue'
import {toRefs, computed} from 'vue'

//Emits and props
const props = defineProps({
  numSteps: {
    type: Number,
    default: 0,
  },
  numCompleted: {
    type: Number,
    default: 0,
  },
})

//Progress percentage
const {numSteps, numCompleted} = toRefs(props)
const progress = computed(() => {

  //No steps
  if (!numSteps.value) {
    return 0
  }

  //Fake progress for last step, as it's weird when the user is in the last step
  //but the progress bar is at 100%
  if (numCompleted.value > 0 && numSteps.value === numCompleted.value) {
    const previous = (numCompleted.value - 1) / numSteps.value
    return (previous + 1) / 2
  }

  //Otherwise, use real progress
  return numCompleted.value / numSteps.value
})
</script>

<template>
  <StatusBadge>
    Step {{ numCompleted || 0 }}/{{ numSteps || 0 }}
  </StatusBadge>
  <ProgressBar
    :progress="progress"
    :class="$style.progress"
  />
</template>

<style lang="scss" module>
.progress {
  @media (min-width: 768px) {
    max-width: 30%;
  }
}
</style>
